import { FunctionComponent } from "react";
import { Box } from "@mui/material";
import Link from "./Link";
import { Pages } from "../../types/utils";
import useIsMobileView from "../../utils/hooks/useIsMobileView";
import MenuButton from "./DropDownBurgerMenu";

const style = {
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-evenly",
  },
};

const NavigationMenu: FunctionComponent<{
  links: Pages;
}> = ({ links }) => {
  const IsMobileView = useIsMobileView();

  return (
    <Box sx={style.container}>
      {IsMobileView ? (
        <MenuButton links={links} />
      ) : (
        Object.entries(links).map(([key, value]) => <Link key={key} url={value} text={key} />)
      )}
    </Box>
  );
};

export default NavigationMenu;
